module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('chart', {
    staticClass: "bar-chart",
    attrs: {
      "type": 'bar',
      "data": _vm.graph_data_bar,
      "options": _vm.optionsPointSummaryBar
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-57d56e6a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/measureLiveDiscussion/graphs/individualStudentLDGraph.vue
// module id = 1681
// module chunks = 61